import _get from 'lodash/get';
import _set from 'lodash/set';
import { environment } from '../../../../environments/environment';
import { Injectable } from "@angular/core";

@Injectable()
export class ConfigurationService {
	private conf: any;

	constructor() {
		this.conf = environment || {};
	}

	get(key: string): any {
		return _get(this.conf, key);
	}

	getAsString(key: string): string {
		return this.get(key);
	}

	set(key: string, value: any): void {
		return _set(this.conf, key, value);
	}
}
